var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTorse2Male(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.84 114.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2e2e2e;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #747474;\n      }\n\n      .cls-5 {\n        stroke-width: .3px;\n      }\n\n      .cls-5, .cls-6, .cls-7 {\n        stroke: #2e2e2e;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-6 {\n        stroke-dasharray: 0 0 3 3;\n      }\n\n      .cls-6, .cls-8, .cls-9 {\n        stroke-linecap: round;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #231f20;\n      }\n\n      .cls-7 {\n        stroke-width: .15px;\n      }\n\n      .cls-8 {\n        stroke-width: .23px;\n      }\n\n      .cls-8, .cls-9 {\n        stroke: #fff;\n      }\n\n      .cls-9 {\n        stroke-width: .25px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.01,114h6s3.36.1,7,0h5.5c.5-2.5,2.39-10.38,2.73-11.79l.59-5.25,1.73-.02v6.56l.96,10h5.5c3,0,.3.07,3.5,0,3.5,0,3.04-.15,3.5,0h3.5c0-1,1-10.5,1.04-13.65.32-6.74.5-13.31-.94-21.42-.53-2.15-.62-3.73-2.9-7.91-.18.12-1.47.48-1.82.7-7.74,4.76-16.29,3.27-17.31,3.16-2.98-.32-4.38-1-9.29-1.35-1.46-.1-2.65.2-3.42.19l-2.36,6.28-2,20-1.5,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.95,4.64c-.98,3.55-.37,5.98,0,7.06.17.49.32.92.67,1.43,1.08,1.56,2.66,2.67,5.42,3.7.96.36,3.54,1.06,5.2,1.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.69,18.77c1.14-.16,4.46.02,4.33,0,.37.06,1.84.37,3.42,2.26,2.74,3.28,3.48,8.56,3.2,11.65-.04.45-.18,1.64,0,3.23l-.22,12.62c-.61,4.71.02,4.27-.6,6.54-.73,2.71-1.94,4.47-4.01,7.44-1.34,1.92-3.31,5.17-6.02,7.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.21,31.6c0,1.95.28,3.72.06,4.9,0,0-.25,3.55-1.1,5.26-.25.51-.56.93-.56.93,0,0-1.09,1.7-1.39,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M46.32,113.98c.41-3.17.9-7.66,1.19-13.08.42-7.87.7-13.14-.37-19.69-.6-3.67-.7-4.63-3.42-10.69-.14.23,2.39-2.01,1.32-7.01-.81-3.8-1.38-8.32-.88-9.88.88-2.76,1.77-5.52,1.65-11.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8.92,31.98c.37.61.65,2.01.8,3.14.11.81.03,2.95,0,3.18-.43,3.56-.07,9.05,0,10,.34,4.47.72,3.69,1.37,8.57.32,2.36-.95,4.86-.95,11.44,0,3.28,1.5,4.83,1.5,4.83-.22,1.98-1.93,5.4-2.17,7.95-.14,1.46-.4,2.66-.46,3.46-.91,4.26-.58,8.8-1.28,13.6-.81,5.48-1.19,10.68-1.54,15.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.6,113.68c.8-3.69,1.64-7.42,2.53-11.2.45-1.92.37-3.67.84-5.56.62.05,1.24.1,1.86.15.28,0,.58-.02.89-.05,1.02-.1,1.9-.35,2.6-.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.51,113.68c-.25-3.15-.49-6.31-.74-9.47-.27-2.39-.05-4.78-.32-7.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.59,5.88c.04.45,0,4.63-.41,6-.1.32-.41,1.61-1.1,2.49-1.3,1.67-1.94,2.04-3.74,2.71-1.22.45-2.9,1.02-7.03,3.11l-2.31.53c-.48.17-1.79.62-2.9,1.5-1.49,1.19-1.96,1.51-3.21,11.25-.48,3.76-.73,5.47-.74,6.9-.05,3.88.69,4.92.91,10.75.14,3.73-.08,3.76.22,5.18.44,2.07.63,5.57,3.42,9.43,1.59,2.2,3.81,5.08,6.72,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.77,37.46s-.17,6.28,1.63,7.23l-1.63-7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M9.77,37.46s-.17,6.28,1.63,7.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.78.44c.07,1.17-1.41,1.88-1.41,1.88v-.08c0,1.03-.14,2.95-1.17,5.04-.61,1.23-1.85,2.47-2.85,3.19-.88.63-1.91.99-2.99,1.03-1.11.04-2.2-.26-3.14-.86-.94-.6-1.92-1.61-2.86-3.04-1.62-2.46-1.85-4.51-1.96-5.67h.04s-1.26-.76-1.35-1.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36.78.44c.07,1.17-1.41,1.88-1.41,1.88v-.08c0,1.03-.14,2.95-1.17,5.04-.61,1.23-1.85,2.47-2.85,3.19-.88.63-1.91.99-2.99,1.03-1.11.04-2.2-.26-3.14-.86-.94-.6-1.92-1.61-2.86-3.04-1.62-2.46-1.85-4.51-1.96-5.67h.04s-1.26-.76-1.35-1.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27.88,61.71c0-.72.39-1.31.87-1.31s.87.59.87,1.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M42.01,47s4.5-1.5,6-4.5c3.5-5.5,0-6.5,1-9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14.49,48.6s-4.5-1.5-6-4.5c-3.5-5.5,0-6.5-1-9.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M28.31,78.35s1.73,17.17-.48,18.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.3,73.87c17.58,2.03,19.37,3.27,32.48-3.06l1.11,2.77c-8.63,6.25-20.91,6.14-34.24,3.06l.65-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.56,74.07s1.23,1.63.8,3.57l1.92-.55s.62-2.5-.62-3.6l-2.1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.53,74.99s-1.23,2-.8,4l-1.92-.56s-.62-2.46.62-3.6l2.1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.48,73.8s-.84,2.3-.55,4.55l-1.31-.63s-.44-2.72.41-4l1.45.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.99,71.28s.78,1.89.51,4.14l1.22-.63s.46-2.79-.33-4.07l-1.4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M27.34,75.41l3.69-.14c.23,0,.22.34.24.54l.21,2.29c.02.21.06.59-.18.6l-3.71.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M30.44,77s.85.36,1.23-.17"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 33.06,
    cy: 76.64,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 29.09,
    cy: 77.1,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 26.37,
    cy: 77.03,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.37,
    cy: 76.07,
    r: 0.19
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.66,77.34c.28,3.74-.77,7.55-2.74,10.72,1.8-3.27,2.83-6.98,2.74-10.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.1,89.41c-.51,8.05-.98,16.26-3.3,24.01,2.03-7.82,2.72-16.02,3.3-24.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.44,89.41c.89,8.12,1.02,16.53-1.04,24.48,1.77-8,1.86-16.39,1.04-24.48h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorse2Male);
export default __webpack_public_path__ + "static/media/torse-2-male.2b8abcbc9b6288167c5ff44ef2fe2bab.svg";
export { ForwardRef as ReactComponent };